import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fide-chesscompetition',
  templateUrl: './fide-chesscompetition.component.html',
  styleUrls: ['./fide-chesscompetition.component.scss']
})
export class FideChesscompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
